import { getRCAData } from '@src/api/rca';
import useQueryParams from '@src/components/widget-panel/hooks/useQueryParams';
import useWidgetQuery from '@src/components/widget-panel/hooks/useWidgetQuery';
import { flattenData } from '@src/utils/table/parseUtils';
import { get } from 'lodash';

const buildQuery = ({ filter, interval, lowerBound }) => {
  return {
    interval,
    metricFilter: [
      {
        metric: 'AverageRequestDuration',
        rule: {
          type: 'bound',
          dimension: 'avg_request_duration_distribution',
          lower: lowerBound,
        },
      },
    ],
    filter,
  };
};

function useFetchRCA({ wid, lowerBound }) {
  const { interval, filter, _rKey, liveMode } = useQueryParams();
  const query = buildQuery({ interval, filter, lowerBound });

  return useWidgetQuery({
    wid,
    queryKey: ['widget', 'network-rca', query],
    queryFn: () =>
      getRCAData(query).then((response) => {
        const { metadataFilterData, metricFilterData, rcaData } = get(response, ['data'], {});
        return {
          metadataFilterData: flattenData(metadataFilterData, { metrics: [] }),
          metricFilterData: flattenData(metricFilterData, { metrics: [] }),
          rcaData,
        };
      }),
    options: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5m
      enabled: !liveMode,
    },
  });
}

export default useFetchRCA;
